import { useTranslation } from 'react-i18next'
import { BrandMark } from '../../app/BrandMark'
import { ButtonLink } from '../../components/Button'
import { Icon } from '../../components/Icon'
import './WelcomePage.css'

/**
 * The public home (M01): the free share-out calculator, which needs no account, and
 * sign-in for members and officers. Bemba and Nyanja join English in P1.
 */
export function WelcomePage() {
  const { t } = useTranslation()
  return (
    <div className="container screen welcome">
      <title>{t('welcome.metaTitle')}</title>
      <section className="welcome__hero">
        <BrandMark size={56} />
        <h1 className="t-title welcome__title">{t('welcome.title')}</h1>
        <p className="welcome__lead">{t('welcome.lead')}</p>
      </section>

      <section className="card welcome__card" aria-labelledby="welcome-calculator">
        <span className="welcome__card-icon">
          <Icon name="calculate" size={28} />
        </span>
        <p className="eyebrow">{t('welcome.calculator.eyebrow')}</p>
        <h2 id="welcome-calculator" className="t-heading">
          {t('welcome.calculator.title')}
        </h2>
        <p className="t-muted">{t('welcome.calculator.body')}</p>
        <ButtonLink to="/calculator" icon="calculate" iconEnd="arrow_forward" fullWidth>
          {t('welcome.calculator.cta')}
        </ButtonLink>
      </section>

      <section className="card welcome__card" aria-labelledby="welcome-signin">
        <span className="welcome__card-icon">
          <Icon name="groups" size={28} />
        </span>
        <p className="eyebrow">{t('welcome.signIn.eyebrow')}</p>
        <h2 id="welcome-signin" className="t-heading">
          {t('welcome.signIn.title')}
        </h2>
        <p className="t-muted">{t('welcome.signIn.body')}</p>
        <ButtonLink to="/signin" variant="secondary" icon="sms" iconEnd="arrow_forward" fullWidth>
          {t('welcome.signIn.cta')}
        </ButtonLink>
      </section>
    </div>
  )
}
